import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

import { fetchUserSubscription as monetizationFetchUserSubscription } from '@picsart/monetization/userService';
import { SubscriptionTierType } from '@picsart/monetization/types';

import { LandingCategory, SubscriptionTypes } from '../constants/enums';
import { UserSubscriptionResponseType, UserSubscriptionState } from './types';

const compare = (a, b) => {
  return a === b || shallow(a, b);
};
const useSubscriptionStore = createWithEqualityFn<UserSubscriptionState>(
  set => ({
    subscription: null,
    loading: true,
    isMaximizer: null,
    redirectTo: null,
    setRedirectTo: (redirectTo: string) => set({ redirectTo }),
    fetchUserSubscription: (
      accessToken: string,
      category: LandingCategory,
      isHomePage: boolean,
    ): Promise<void | UserSubscriptionResponseType> =>
      monetizationFetchUserSubscription({ expand: true }, accessToken)
        .then(resp => {
          const nonMaxTiers: SubscriptionTierType[] = [
            SubscriptionTypes.pro,
            SubscriptionTypes.plus,
            SubscriptionTypes.gold,
            ...(isHomePage ? [SubscriptionTypes.free] : []),
          ];
          const isMaximizer =
            (isHomePage || category === LandingCategory.maximizer) &&
            !nonMaxTiers.includes(resp?.data?.tier_meta?.id);

          set({
            loading: false,
            subscription: resp?.data?.tier_meta?.id,
            isMaximizer,
          });
          return { isMaximizer, subscription: resp?.data?.tier_meta?.id };
        })
        .catch(() => set({ loading: false, subscription: null, isMaximizer: null })),
  }),
  compare,
);

export default useSubscriptionStore;
